export default __webpack_public_path__ + "static/media/53 Htet Wai Htoo.19604cce.jpg";